import React from "react";
import CompanyAllUsers from "./CompanyAllUsers";

export default function Users() {
  return (
    <div>
      <CompanyAllUsers />
    </div>
  );
}
